import { getAddLevel3Group } from '../../api/groupinglist'
import { getGroupList } from '../../api/task'
const GroupingList = {
    state: {
        Grouping: [],
        Grouplist: []
    },
    mutations: {
        GET_DEVICELIST(state, data) {
            state.Grouping = data
        },
        GET_GROUPLIST(state, data) {
            state.Grouplist = data
        }
    },
    actions: {
        getLevel3Group({ commit },pid ) {
            //触发actions获取所有分组数据
            getAddLevel3Group(pid)
                .then((res) => {
                    if (res.data.code === 0) {
                        commit('GET_DEVICELIST', res.data.queryResult)
                    }
                })
        },
        //获取所有分组列表,并且查询分组下的所有在线设备列表
        getGroupList({ commit }, allDevice) {
            getGroupList(allDevice)
                .then((res) => {
                    if (res.data.code === 0) {
                        commit('GET_GROUPLIST', res.data.data.list)
                    }
                })
        }
    }
}

export default GroupingList
